import { useState, useEffect } from 'react';
import { Modal, Row, Col, Form, InputGroup } from 'react-bootstrap';
import { toast } from 'react-toastify'
import * as Yup from 'yup'
import { Formik, Field } from 'formik'
import { useSelector } from 'react-redux';

import lib from '../biz/lib'
import eTenanciesBiz from '../biz/eTenanciesBiz';

// setup data
import SetupData from '../data/SetupData'
import DatePickerModal from '../components/DatePickerModal';
import activeTenantBiz from '../biz/activeTenantBiz';

const TenancyRenewalModal = (props) => {
    const { modal, setModal, formData, setFormData, handleCancel, mode } = props

    const [data, setData] = useState({})
    const [formMode, setFormMode] = useState('')
    const [submitAction, setSubmitAction] = useState('')
    const [loading, setLoading] = useState(false)
    const [alertModal, setAlertModal] = useState(false)

    const userSlice = useSelector((state) => state.user);
    const requiredMsg = 'This field is required'
    const isManagement = userSlice?.role === 'Admin' || userSlice?.role === 'Operator' || userSlice?.role === 'Owner' || userSlice?.role === 'Office'

    //tenancy start date (prev end date + 1 day)
    const prevEndDate = data?.tenancy?.endDate || formData?.tenancyEndDate
    const startDate = prevEndDate ? new Date(prevEndDate) : null;
    if (startDate) {
        startDate.setDate(startDate.getDate() + 1);
    }

    const populateEtenancyData = async () => {
        const result = await eTenanciesBiz.getById(formData?.eTenancies)
        if (result) {
            setData(result)
        }
    }

    useEffect(() => {
        if (modal && mode !== 'review' && formData?.eTenancies) {
            populateEtenancyData()
        }
        setFormMode(mode)
    }, [modal, mode, formData])

    const initialValues = {
        startDate: new Date(startDate),
        endDate: '',
        tenancyPeriod: '',
        otherPeriod: '',
        propertyUnitName: data?.propertyUnit?.code || formData?.propertyUnitName,
        propertyUnit: data?.propertyUnit?._id || formData?.propertyUnit?._id,
        propertyRoomName: data?.propertyRoom?.name || formData?.propertyRoomName,
        propertyRoom: data?.propertyRoom?._id || formData?.propertyRoom?._id,
        rental: data?.propertyUnit?.basicMonthlyRental || formData?.tenancyRenew?.rental,
    }

    const initialValues1 = {
        startDate: formData?.tenancyRenew?.tenancy?.startDate,
        endDate: formData?.tenancyRenew?.tenancy?.endDate,
        tenancyPeriod: formData?.tenancyRenew?.tenancy?.period,
        otherPeriod: formData?.tenancyRenew?.tenancy?.otherPeriod,
        propertyUnitName: formData?.propertyUnitName,
        propertyUnit: formData?.propertyUnit?._id,
        propertyRoomName: formData?.propertyRoomName,
        propertyRoom: formData?.propertyRoom?._id,
        rental: formData?.tenancyRenew?.rental,
        status: formData?.tenancyRenew?.status,
        ...(formData?.tenancyRenew?.status === 'Rejected' && {
            reason: formData?.tenancyRenew?.rejected?.reason
        })
    }

    const validationSchema = Yup.object().shape({
        tenancyPeriod: Yup.string().required(requiredMsg),
        otherPeriod: Yup.string().when('tenancyPeriod', {
            is: (val) => val === 'Other',
            then: () => Yup.string().required(requiredMsg),
            otherwise: () => Yup.string(),
        }),
        rental: isManagement ? Yup.string().required(requiredMsg) : Yup.string(),
    })


    const handleClose = () => {
        setModal(false)
        setLoading(false)
        setData({})
        setFormData({})
        setSubmitAction('')
        setFormMode('')
    }

    return (
        <>
            <Modal
                id='kt_modal_create_app'
                tabIndex={-1}
                aria-hidden='true'
                dialogClassName='modal-dialog modal-dialog-centered mw-624px'
                show={modal}
                onHide={handleClose}
                backdrop={true}
                size={"lg"}
            >
                <Modal.Body>
                    <div className=''>
                        <h4>Tenancy Renewal Form</h4>
                        <div className='flex-row-fluid py-lg-5 px-lg-15'>
                            <form id='kt_modal_create_app_form'>
                                <div className='current' data-kt-stepper-element='content'>
                                    <Formik
                                        enableReinitialize
                                        initialValues={formMode === 'review' ? initialValues1 : initialValues}
                                        validationSchema={validationSchema}
                                        onSubmit={async (values, { setSubmitting }) => {
                                            setSubmitting(false)
                                            setLoading(true)
                                            try {
                                                if (submitAction === 'Submitted' || submitAction === 'Resubmit') {
                                                    const isResubmit = submitAction === 'Resubmit'

                                                    const params = {
                                                        ...values,
                                                        eTenancies: data?._id || formData?._id,
                                                        status: 'Submitted',
                                                        by: userSlice?._id,
                                                        ...(isResubmit && {
                                                            action: 'resubmit',
                                                        }),
                                                    }

                                                    const result = await activeTenantBiz.saveTenancyRenewal(params)

                                                    if (result) {
                                                        if (!isResubmit) {
                                                            handleCancel?.([formData?._id])
                                                        }

                                                        toast.success('Renewal request has been submitted successfully')
                                                    } else {
                                                        toast.error('Something went wrong, please try again later.')
                                                    }

                                                    handleClose()
                                                } else {
                                                    setAlertModal(true)
                                                    setData(values)
                                                }

                                            } catch (err) {
                                                throw err

                                            }
                                        }}
                                    >
                                        {(props) => {
                                            const {
                                                values,
                                                touched,
                                                errors,
                                                dirty,
                                                isSubmitting,
                                                handleChange,
                                                handleBlur,
                                                handleSubmit,
                                                handleReset,
                                                setFieldValue,
                                                resetForm
                                            } = props

                                            const isReviewMode = formMode === 'review';
                                            const isRenewMode = formMode === 'renew';
                                            const isResubmitMode = formMode === 'resubmit'
                                            const isTenant = userSlice?.role === 'Tenant';
                                            const tenancyRenewSubmitted = formData?.tenancyRenew?.status === 'Submitted';

                                            const isFieldDisabled = isReviewMode && (
                                                isTenant || !tenancyRenewSubmitted
                                            );

                                            // get min date for new tenancy (prev end date + 1)
                                            const prevEndDate = new Date(formData?.tenancyEndDate)
                                            prevEndDate.setDate(prevEndDate.getDate() + 1)

                                            const getTenancyMonths = (period) => {
                                                if (period === '6 Months') return 6;
                                                if (period === '1 Year') return 12;
                                                if (period === '2 Year') return 24;
                                                if (period === 'Other') return Number(values.otherPeriod);

                                                return 0;
                                            };

                                            const calculateEndDate = (startDate, months) => {
                                                if (!startDate || !months) {
                                                    return null;
                                                }

                                                const endDate = new Date(startDate);

                                                endDate.setMonth(endDate.getMonth() + Number(months));
                                                endDate.setDate(endDate.getDate() - 1);

                                                return endDate;
                                            };

                                            return (
                                                <>
                                                    <Row>
                                                        <Col sm='12' md='6'>
                                                            <Form.Group className='mb-3' controlId='propertyUnitName'>
                                                                <Form.Label md='3' className='required'>
                                                                    Unit Name
                                                                </Form.Label>
                                                                :
                                                                <Form.Control
                                                                    type='text'
                                                                    size='sm'
                                                                    placeholder='Property Unit Name'
                                                                    defaultValue={values.propertyUnitName}
                                                                    onChange={handleChange}
                                                                    disabled
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm='12' md='6'>
                                                            <Form.Group className='mb-3' controlId='propertyRoomName'>
                                                                <Form.Label md='3' className='required'>
                                                                    Room Name
                                                                </Form.Label>
                                                                :
                                                                <Form.Control
                                                                    type='text'
                                                                    size='sm'
                                                                    placeholder='Property Room Name'
                                                                    defaultValue={values.propertyRoomName}
                                                                    onChange={handleChange}
                                                                    disabled
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col sm='12' md='6'>
                                                            <Form.Group className='mb-3' controlId='rental'>
                                                                <Form.Label md='3' className='required'>
                                                                    Monthly Rental Fee
                                                                </Form.Label>
                                                                :
                                                                <InputGroup size='sm'>
                                                                    <InputGroup.Text id='basic-addon1'>RM</InputGroup.Text>
                                                                    <Field
                                                                        className='form-control no-border'
                                                                        type='text'
                                                                        name='rental'
                                                                        size='sm'
                                                                        value={lib.numberFormatter(values.rental, 2)}
                                                                        placeholder='rental'
                                                                        disabled={!tenancyRenewSubmitted}
                                                                    />
                                                                    <InputGroup.Text id='basic-addon1'>per month</InputGroup.Text>
                                                                </InputGroup>
                                                            </Form.Group>
                                                            {touched.rental && !values.rental && (
                                                                <p className='formik-error-msg'>This field is required</p>
                                                            )}
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col>
                                                            <Form.Group
                                                                className='mb-3 align-items-center'
                                                                controlId='tenancyPeriod'
                                                            >
                                                                <Form.Label md='3' className='required'>
                                                                    Tenancy Period
                                                                </Form.Label>
                                                                :
                                                                <Form.Select
                                                                    size='sm'
                                                                    name='tenancyPeriod'
                                                                    value={values.tenancyPeriod}
                                                                    onChange={(e) => {
                                                                        const period = e.target.value;

                                                                        setFieldValue('tenancyPeriod', period);

                                                                        if (!values.startDate || !period) {
                                                                            setFieldValue('endDate', null);
                                                                            return;
                                                                        }

                                                                        if (period === 'Other') {
                                                                            setFieldValue('endDate', null);
                                                                            return;
                                                                        }

                                                                        const months = getTenancyMonths(period);
                                                                        const endDate = calculateEndDate(values.startDate, months);

                                                                        setFieldValue('endDate', endDate);
                                                                    }}
                                                                    onBlur={handleBlur}
                                                                    disabled={isFieldDisabled}
                                                                >
                                                                    {SetupData.tenancyPeriod.map((obj) => (
                                                                        <option key={obj.value} value={obj.value}>
                                                                            {obj.label}
                                                                        </option>
                                                                    ))}
                                                                </Form.Select>
                                                            </Form.Group>
                                                            {touched.tenancyPeriod && errors.tenancyPeriod && (
                                                                <p className='formik-error-msg'>{errors.tenancyPeriod}</p>
                                                            )}
                                                        </Col>
                                                        {values.tenancyPeriod === 'Other' && (
                                                            <Col>
                                                                <Form.Group
                                                                    className='mb-3 align-items-center'
                                                                    controlId='otherPeriod'
                                                                >
                                                                    <Form.Label md='3' className='required'>
                                                                        Other Period:
                                                                    </Form.Label>
                                                                    <InputGroup size='sm'>
                                                                        <Form.Select
                                                                            size='sm'
                                                                            name='otherPeriod'
                                                                            value={values.otherPeriod}
                                                                            onChange={(e) => {
                                                                                const otherPeriod = e.target.value;

                                                                                setFieldValue('otherPeriod', otherPeriod);

                                                                                if (!values.startDate || !otherPeriod) {
                                                                                    setFieldValue('endDate', null);
                                                                                    return;
                                                                                }

                                                                                const endDate = calculateEndDate(
                                                                                    values.startDate,
                                                                                    Number(otherPeriod)
                                                                                );

                                                                                setFieldValue('endDate', endDate);
                                                                            }}
                                                                            onBlur={handleBlur}
                                                                            disabled={isFieldDisabled}
                                                                        >
                                                                            <option value=''>Select Months</option>

                                                                            {Array.from({ length: 24 }, (_, index) => {
                                                                                const period = index + 1;

                                                                                return (
                                                                                    <option key={period} value={period}>
                                                                                        {period}
                                                                                    </option>
                                                                                );
                                                                            })}
                                                                        </Form.Select>
                                                                        <InputGroup.Text id='basic-addon1'>month(s)</InputGroup.Text>
                                                                    </InputGroup>
                                                                </Form.Group>
                                                            </Col>
                                                        )}
                                                    </Row >

                                                    {(values.tenancyPeriod || (values.tenancyPeriod === "Other" && values.otherPeriod)) &&
                                                        <Row>
                                                            <Col sm='12' md='6'>
                                                                <Form.Group className='mb-3' controlId='startDate'>
                                                                    <Form.Label md='3' className='required'>
                                                                        Estimate Check In Date
                                                                    </Form.Label>
                                                                    :
                                                                    <div className='css-b62m3t-container'>
                                                                        <DatePickerModal
                                                                            className='form-control form-control-sm'
                                                                            wrapperClassName='custom-date-picker-wrapper'
                                                                            dateFormat='dd/MM/yyyy'
                                                                            placeholderText='dd/mm/yyyy'
                                                                            minDate={prevEndDate}
                                                                            selected={
                                                                                values?.startDate
                                                                                    ? new Date(values?.startDate)
                                                                                    : ''
                                                                            }
                                                                            onChange={(date) => {
                                                                                setFieldValue('startDate', date);

                                                                                if (!date || !values.tenancyPeriod) {
                                                                                    setFieldValue('endDate', null);
                                                                                    return;
                                                                                }

                                                                                const months = getTenancyMonths(values.tenancyPeriod);

                                                                                if (!months) {
                                                                                    setFieldValue('endDate', null);
                                                                                    return;
                                                                                }

                                                                                const endDate = calculateEndDate(date, months);

                                                                                setFieldValue('endDate', endDate);
                                                                            }}
                                                                            minimumYear={new Date().getFullYear() - 5}
                                                                            maximumYear={new Date().getFullYear() + 5}
                                                                            disabled={isFieldDisabled}
                                                                        />
                                                                    </div>
                                                                </Form.Group>
                                                                {touched.startDate && errors.startDate && (
                                                                    <p className='formik-error-msg'>{errors.startDate}</p>
                                                                )}
                                                            </Col>
                                                            <Col sm='12' md='6'>
                                                                <Form.Group className='mb-3' controlId='endDate'>
                                                                    <Form.Label md='3' className='required'>
                                                                        Estimate Check Out Date
                                                                    </Form.Label>
                                                                    :
                                                                    <div class='css-b62m3t-container'>
                                                                        <DatePickerModal
                                                                            className='form-control form-control-sm'
                                                                            wrapperClassName='custom-date-picker-wrapper'
                                                                            dateFormat='dd/MM/yyyy'
                                                                            placeholderText='dd/mm/yyyy'
                                                                            minDate={new Date(values?.endDate)}
                                                                            selected={
                                                                                values?.endDate ? new Date(values?.endDate) : ""
                                                                            }
                                                                            onChange={(date) => setFieldValue('endDate', date)}
                                                                            minimumYear={new Date().getFullYear() - 5}
                                                                            maximumYear={new Date().getFullYear() + 5}
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                </Form.Group>
                                                                {touched.endDate && errors.endDate && (
                                                                    <p className='formik-error-msg'>{errors.endDate}</p>
                                                                )}
                                                            </Col>
                                                        </Row>
                                                    }

                                                    {isReviewMode &&
                                                        <>
                                                            <Row>
                                                                <Form.Group className='mb-3' controlId='status'>
                                                                    <Form.Label md='3' className='required'>
                                                                        Status
                                                                    </Form.Label>
                                                                    :
                                                                    <Form.Control
                                                                        type='text'
                                                                        size='sm'
                                                                        placeholder='Status'
                                                                        defaultValue={values.status}
                                                                        disabled
                                                                    />
                                                                </Form.Group>
                                                            </Row>
                                                            {formData?.tenancyRenew?.status === 'Rejected' &&
                                                                <Row>
                                                                    <Form.Group className='mb-3' controlId=''>
                                                                        <Form.Label md='3' className='required'>
                                                                            Reason
                                                                        </Form.Label>
                                                                        :
                                                                        <Form.Control
                                                                            type='text'
                                                                            size='sm'
                                                                            placeholder='Reason'
                                                                            defaultValue={values.reason}
                                                                            disabled
                                                                        />
                                                                    </Form.Group>
                                                                </Row>
                                                            }
                                                        </>
                                                    }
                                                    <br />
                                                    <div className='modal-action'>
                                                        {((isRenewMode || isResubmitMode) && isTenant) && (
                                                            <button
                                                                type='button'
                                                                className='btn btn-lg btn-primary'
                                                                data-kt-stepper-action='submit'
                                                                onClick={() => {
                                                                    setSubmitAction('Submitted')
                                                                    handleSubmit()
                                                                }}
                                                                disabled={loading}
                                                            >
                                                                {!loading && (
                                                                    <span className='indicator-label'>
                                                                        Submit Renewal Request
                                                                    </span>
                                                                )}

                                                                {loading && (
                                                                    <span
                                                                        className='indicator-progress'
                                                                        style={{ display: 'block' }}
                                                                    >
                                                                        Please wait...
                                                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                                                    </span>
                                                                )}
                                                            </button>
                                                        )}

                                                        {(isReviewMode && isManagement && tenancyRenewSubmitted) && (
                                                            <>
                                                                <button
                                                                    type='button'
                                                                    className='btn btn-lg btn-primary'
                                                                    data-kt-stepper-action='submit'
                                                                    onClick={() => {
                                                                        setSubmitAction('Approved')
                                                                        handleSubmit()
                                                                    }}
                                                                    disabled={loading}
                                                                >
                                                                    {!(submitAction === 'Approved' && loading) && (
                                                                        <span className='indicator-label'>
                                                                            Approve
                                                                        </span>
                                                                    )}

                                                                    {(submitAction === 'Approved' && loading) && (
                                                                        <span
                                                                            className='indicator-progress'
                                                                            style={{ display: 'block' }}
                                                                        >
                                                                            Please wait...
                                                                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                                                        </span>
                                                                    )}
                                                                </button>

                                                                <button
                                                                    type='button'
                                                                    className='btn btn-lg btn-primary'
                                                                    data-kt-stepper-action='submit'
                                                                    onClick={() => {
                                                                        setSubmitAction('Rejected')
                                                                        handleSubmit()
                                                                    }}
                                                                    disabled={loading}
                                                                >
                                                                    {!(submitAction === 'Rejected' && loading) && (
                                                                        <span className='indicator-label'>
                                                                            Reject
                                                                        </span>
                                                                    )}

                                                                    {(submitAction === 'Rejected' && loading) && (
                                                                        <span
                                                                            className='indicator-progress'
                                                                            style={{ display: 'block' }}
                                                                        >
                                                                            Please wait...
                                                                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                                                        </span>
                                                                    )}
                                                                </button>
                                                            </>
                                                        )}

                                                        {(isReviewMode && userSlice.role === 'Tenant') &&
                                                            <button
                                                                type='button'
                                                                className='btn btn-lg btn-primary'
                                                                data-kt-stepper-action='submit'
                                                                onClick={() => {
                                                                    setSubmitAction('Resubmit')
                                                                    setFormMode('resubmit')
                                                                    resetForm()
                                                                }}
                                                                disabled={loading}
                                                                hidden={values.status !== 'Rejected'}
                                                            >
                                                                {!(submitAction === 'Resubmit' && loading) && (
                                                                    <span className='indicator-label'>
                                                                        Resubmit Tenancy Renewal
                                                                    </span>
                                                                )}

                                                                {(submitAction === 'Resubmit' && loading) && (
                                                                    <span
                                                                        className='indicator-progress'
                                                                        style={{ display: 'block' }}
                                                                    >
                                                                        Please wait...
                                                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                                                    </span>
                                                                )}
                                                            </button>
                                                        }

                                                        <button
                                                            type='button'
                                                            className='btn btn-lg btn-light-primary me-3'
                                                            data-kt-stepper-action='previous'
                                                            onClick={handleClose}
                                                            disabled={loading}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>
                                                </>
                                            )
                                        }}
                                    </Formik>
                                </div>
                            </form>
                        </div>
                    </div>
                </Modal.Body >
            </Modal >
            <AlertModal
                alertModal={alertModal}
                setAlertModal={setAlertModal}
                submitAction={submitAction}
                formData={formData}
                data={data}
                setData={setData}
                setLoading={setLoading}
                userSlice={userSlice}
                handleCloseReview={handleClose}
            />
        </>
    )
}

export default TenancyRenewalModal

const AlertModal = (props) => {

    const { alertModal, setAlertModal, submitAction, formData, data, setData, setLoading, userSlice, handleCloseReview } = props

    const [pending, setPending] = useState(false)
    const [reason, setReason] = useState('')
    const action = submitAction === 'Approved' ? 'approve' : 'reject'

    const handleSubmit = async () => {
        try {
            setPending(true)
            const params = {
                ...data,
                recordId: formData?.tenancyRenew?._id,
                status: submitAction,
                by: userSlice?._id,
                ...(submitAction === 'Rejected' && {
                    reason
                })
            }

            const result = await activeTenantBiz.updateTenancyRenewal(params)

            if (result) {
                handleCloseReview()
                toast.success(`Renewal request has been ${submitAction.toLowerCase()}`)
            } else {
                toast.error('Something went wrong, please try again later.')
            }
        } catch (err) {
            throw err
        } finally {
            handleClose()
        }
    }

    const handleClose = () => {
        setLoading(false)
        setPending(false)
        setAlertModal(false)
        setReason('')
        setData({})
    }

    return (
        <Modal
            id='kt_modal_create_app'
            tabIndex={-1}
            aria-hidden='true'
            dialogClassName='modal-dialog modal-dialog-centered mw-624px'
            show={alertModal}
            onHide={handleClose}
            backdrop={true}
            size={"lg"}
        >
            <Modal.Body>
                <div className=''>
                    <div className='flex-row-fluid py-lg-5 px-lg-15'>
                        <form id='kt_modal_create_app_form'>
                            <div className='current' data-kt-stepper-element='content'>
                                <span>
                                    Do you wish to <b>{action}</b> this tenancy renewal request for tenant <b>{formData?.tenantName}</b> in property unit <b>{formData?.propertyUnitName}</b>, room <b>{formData?.propertyRoomName}</b> ?
                                </span>
                                <br />
                                <b>Please note that this action cannot be undone.</b>
                                {submitAction === 'Rejected' && (
                                    <>
                                        <br />
                                        <br />
                                        <Row>
                                            <Col>
                                                <div className='mb-3'>
                                                    <label className='form-label required'>Reason</label>:
                                                    <textarea
                                                        className='form-control'
                                                        rows={4}
                                                        value={reason}
                                                        onChange={(e) => setReason(e.target.value)}
                                                        placeholder='Please enter the reason for rejection'
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                                <br />
                                <br />
                                <div className='modal-action'>
                                    <button
                                        type='button'
                                        className='btn btn-lg btn-primary'
                                        data-kt-stepper-action='submit'
                                        onClick={handleSubmit}
                                        disabled={pending}
                                    >
                                        {!pending && <span className='indicator-label'>Confirm</span>}
                                        {pending && (
                                            <span className='indicator-progress' style={{ display: 'block' }}>
                                                Please wait...
                                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                            </span>
                                        )}
                                    </button>
                                    <button
                                        type='button'
                                        className='btn btn-lg btn-light-primary me-3'
                                        data-kt-stepper-action='previous'
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal.Body >
        </Modal >
    )
}